<tabbed-detail-base [tabs]="navTabs()" [(activeTabIndex)]="activeTabIndex">
  <span heading>{{ "ServiceElement.ConnectedPorts" | translate }}</span>

  @if (showModifyButton()) {
    <modify-l2vpn-fw-button
      action-button
      [subscription]="subscription()"
      [isInfrastructureDelegate]="isInfrastructureDelegate()"
      (clicked)="openSelfserviceDialog($event)"
    />
  }

  @if (activeFirewallInterconnect(); as interconnect) {
    <l2vpn-firewall-interconnect-panel tab-content [interconnect]="interconnect" />
  }
  @if (activeEsi(); as esi) {
    <l2vpn-esi-panel tab-content [esi]="esi" />
  }
</tabbed-detail-base>
